// eslint-disable-next-line no-unused-vars
export default (element, data) => {
  const init = () => {
    console.log('recs carousel js');
  };

  init();
};
